import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

export var activatePermission = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(admin_id, permission_code, token) {
    var url, response, responseJson;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            url = "/api/v1/admins/".concat(admin_id, "/permissions/");
            _context.next = 3;
            return fetch(url, {
              method: "POST",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                // Added Content-Type header
                "X-CSRF-Token": token
              },
              body: JSON.stringify({
                code: permission_code
              })
            });

          case 3:
            response = _context.sent;
            _context.next = 6;
            return response.json();

          case 6:
            responseJson = _context.sent;
            return _context.abrupt("return", responseJson);

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function activatePermission(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
export var disablePermission = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(admin_id, permission_code, token) {
    var url, response, responseJson;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            url = "/api/v1/admins/".concat(admin_id, "/permissions/");
            _context2.next = 3;
            return fetch(url, {
              method: "DELETE",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                // Added Content-Type header
                "X-CSRF-Token": token
              },
              body: JSON.stringify({
                code: permission_code
              })
            });

          case 3:
            response = _context2.sent;
            _context2.next = 6;
            return response.json();

          case 6:
            responseJson = _context2.sent;
            return _context2.abrupt("return", responseJson);

          case 8:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function disablePermission(_x4, _x5, _x6) {
    return _ref2.apply(this, arguments);
  };
}();
export var changeSuperAdmin = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(admin_id, token) {
    var url, response, responseJson;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            url = "/api/v1/admins/".concat(admin_id, "/change_super_admin/");
            _context3.next = 3;
            return fetch(url, {
              method: "POST",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                // Added Content-Type header
                "X-CSRF-Token": token
              }
            });

          case 3:
            response = _context3.sent;
            _context3.next = 6;
            return response.json();

          case 6:
            responseJson = _context3.sent;
            return _context3.abrupt("return", responseJson);

          case 8:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function changeSuperAdmin(_x7, _x8) {
    return _ref3.apply(this, arguments);
  };
}();